<template>
  <component
    :is="'button'"
    :type="nativeType"
    class="btn"
    :disabled="disabled"
    :class="classes"
  >
    <el-tooltip
      v-if="icon"
      class="box-item"
      effect="dark"
      :content="icon.description"
      placement="bottom"
      :disabled="!icon.description"
    >
      <i :class="iconClass" />
    </el-tooltip>
    <span
      v-if="$slots.label"
      class="btn-label"
    >
      <slot name="label" />
    </span>
    <slot />
    <span
      v-if="$slots.labelRight"
      class="btn-label btn-label-right"
    >
      <slot name="labelRight" />
    </span>
  </component>
</template>

<script setup lang="ts">
interface Icon {
  description: string | null;
  iconName: string | null;
}

import { computed } from 'vue';

const props = defineProps({
  type: {
    type: String,
    default: 'default',
    description: 'Color type',
  },
  nativeType: {
    type: String,
    default: 'button',
    description: 'Native button type (e.g submit|button) ',
  },
  round: {
    type: Boolean,
    default: false,
  },
  outline: {
    type: Boolean,
    default: false,
  },
  block: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: Object as () => Icon,
    default: null,
  },
});

const classes = computed(() => {
  let btnClasses = [
    { [`btn-outline-${props.type}`]: props.outline },
    { 'btn-round': props.round },
    { 'btn-block': props.block },
    { 'disabled-button': props.disabled },
    `btn-${props.type}`,
  ];

  if (props.size) {
    btnClasses.push(`btn-${props.size}`);
  }

  return btnClasses;
});

const iconClass = computed(() => `fa ${props.icon.iconName}` || null);
</script>
